import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import FilteringSidePanel from "../../../../../../shared/oversight-core/shared-components/filtering-side-panel/filtering-side-panel";
import AppDatePicker from "../../../../../../shared/oversight-core/ui-elements/app-date-picker/app-date-picker";
import { formatDateByZoneId } from "../../../../../../shared/oversight-core/utils/date-utils";

interface IProps {
  show: boolean;
  onClose: () => void;
  updateFilters: (startDate: string, endDate: string) => void;
  zoneId?: string;
}

const SiteErrorLogFilterPanel = (props: IProps) => {
  const { show, onClose, updateFilters, zoneId } = props;

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  return (
    <FilteringSidePanel
      isOpen={show}
      onClose={onClose}
      onFilter={() => {
        updateFilters(
          formatDateByZoneId(startDate, zoneId),
          formatDateByZoneId(endDate, zoneId)
        );
        onClose();
      }}
      onClearAll={() => {
        setStartDate(new Date());
        setEndDate(new Date());
        updateFilters("", "");
        onClose();
      }}
    >
      <>
        <Row>
          <Col>
            <AppDatePicker
              label="From"
              selectedDate={startDate}
              onChange={(date) => {
                setStartDate(date);
              }}
              isInput
              inputDateFormat="dd / MM / yyyy"
              fontSize={12}
            />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <AppDatePicker
              label="To"
              selectedDate={endDate}
              onChange={(date) => {
                setEndDate(date);
              }}
              isInput
              inputDateFormat="dd / MM / yyyy"
              fontSize={12}
            />
          </Col>
        </Row>
      </>
    </FilteringSidePanel>
  );
};

export default SiteErrorLogFilterPanel;
